import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router";

import ReactBSAlert from "react-bootstrap-sweetalert";

import TranslatePagesView from "./TranslatePagesView";
import SourceDataModal from "@/components/SourceDataModal";
import {
  translatedpages, deletetrans
} from '@/services/translationservice/translationActions'

/** A translated-page row as this list reads it. */
type TranslatedPageRow = { _id: string; global_title?: string };

const TranslatePagesContainer = () => {
  const [translatePages, setTranslatePages] = useState<TranslatedPageRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<React.ReactNode>(null);
  // SCRUM-1887 (same defect as SCRUM-1885): redirect with navigate(), not a
  // `redirect` state rendered as <Navigate>. An instance that survived a quick
  // browser Back still held that state and rendered nothing.
  const navigate = useNavigate();
  const [sourceDataModalOpen, setSourceDataModalOpen] = useState(false);
  const [selectedSourceData, setSelectedSourceData] = useState<TranslatedPageRow | null>(null);
  const trans = useAppSelector((state) => state.translatedpages.translatedpages);
  const dispatch = useAppDispatch();

useEffect(() => {
  setLoading(true);

  dispatch(translatedpages())
    .finally(() => {
      setLoading(false);
    });
    
}, [dispatch]);


  const hideAlert = useCallback(() => setAlert(null), []);

  const handleDelete = (page: TranslatedPageRow) => {
    const pageTitle = page.global_title || "this page";
    const details = `Are you sure you want to delete the translated page "${pageTitle}"? This action cannot be undone.`;

    setAlert(
      // @ts-expect-error react-bootstrap-sweetalert prop-types (customIcon/btnSize)
      <ReactBSAlert
        custom
        style={{ display: "block", marginTop: "-100px" }}
        title="Delete Translated Page"
        btnSize="md"
        confirmBtnText="Yes, Delete It"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        showCancel
        focusConfirmBtn
        onConfirm={async () => {
          hideAlert();
          dispatch(deletetrans(page._id));

        }}
        onCancel={hideAlert}
      >
        {details}
      </ReactBSAlert>
    );
  };

  const handleEdit = useCallback((pageId: string) => {
    // Navigate to edit translate page interface
    navigate(`/admin/update-translate-page/${pageId}`);
  }, [navigate]);

  const handleSourceDataClick = (page: TranslatedPageRow) => {
    setSelectedSourceData(page);
    setSourceDataModalOpen(true);
  };

  const toggleSourceDataModal = () => {
    setSourceDataModalOpen(!sourceDataModalOpen);
    if (sourceDataModalOpen) {
      setSelectedSourceData(null);
    }
  };



  return (
    <>
      {alert}
      <TranslatePagesView
        translatePages={trans}
        loading={loading}
        onDelete={handleDelete}
        onEdit={handleEdit}
        onSourceDataClick={handleSourceDataClick}
      />

      <SourceDataModal
        isOpen={sourceDataModalOpen}
        toggle={toggleSourceDataModal}
        sourceData={selectedSourceData}
      />
    </>
  );
};

export default TranslatePagesContainer;